import { render, staticRenderFns } from "./TransferWriteXA.vue?vue&type=template&id=98da37fa&scoped=true&"
import script from "./TransferWriteXA.vue?vue&type=script&lang=js&"
export * from "./TransferWriteXA.vue?vue&type=script&lang=js&"
import style0 from "./TransferWriteXA.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TransferWriteXA.vue?vue&type=style&index=1&id=98da37fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98da37fa",
  null
  
)

export default component.exports